import React from 'react';
import cn from 'classnames';

import {
  WidgetHeader as WidgetHeaderType,
  WidgetHeaderType as HeaderType
} from 'widget/entities/config';
import Logo from 'widget/shared/ui/Logo';

import styles from './WidgetHeader.module.scss';
import CloseButton from './CloseButton';

export type WidgetHeaderProps = {
  className?: string;
  onClose?: () => void;
  headerConfig?: WidgetHeaderType;
};

const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  className,
  onClose,
  headerConfig
}) => {
  const renderHeaderContent = () => {
    if (!headerConfig) {
      return (
        <h1 className={styles['header__logo']}>
          <Logo withTitle />
        </h1>
      );
    }

    if (headerConfig.type === HeaderType.logo) {
      if (headerConfig.logoUrl) {
        return (
          <div className={styles['header__logo']}>
            <img
              src={headerConfig.logoUrl}
              alt="Logo"
              className={styles['header__custom-logo']}
            />
          </div>
        );
      }
      return (
        <h1 className={styles['header__logo']}>
          <Logo withTitle />
        </h1>
      );
    }

    if (headerConfig.type === HeaderType.text) {
      return (
        <div className={styles['header__text']}>
          {headerConfig.title && (
            <h1 className={styles['header__title']}>{headerConfig.title}</h1>
          )}
          {headerConfig.subtitle && (
            <p className={styles['header__subtitle']}>
              {headerConfig.subtitle}
            </p>
          )}
        </div>
      );
    }

    return null;
  };

  return (
    <div className={cn(styles['header'], className)}>
      {renderHeaderContent()}
      <CloseButton className={styles['header__close']} onClick={onClose} />
    </div>
  );
};

export default WidgetHeader;
